export { salesFunnelsApi2 } from './api';
export {
  SalesFunnelsEndpoints,
  type SalesFunnelFilterDto,
  type SalesFunnelListStageDto,
  type SalesFunnelListDto,
  type SalesFunnelDto,
  type WriteSalesFunnelDto,
  type ModelSalesFunnelWithStages,
  type ModelSalesFunnelLeadsFilter,
  type ModelSalesFunnelStageLeads,
  type ModelSalesFunnelLeadsSearchResult,
  type GetSalesFunnelRequest,
  type GetSalesFunnelsForFiltersRequest,
  type ListSalesFunnelsRequest,
  type CreateSalesFunnelRequest,
  type UpdateSalesFunnelRequest,
  type DeleteSalesFunnelRequest,
  type CheckSalesFunnelForLeadsRequest,
  type GetUserSalesFunnelsRequest,
  type GetSalesFunnelLeadsRequest,
  type GetSalesFunnelResponse,
  type GetSalesFunnelsForFiltersResponse,
  type ListSalesFunnelsResponse,
  type CreateSalesFunnelResponse,
  type UpdateSalesFunnelResponse,
  type DeleteSalesFunnelResponse,
  type CheckSalesFunnelForLeadsResponse,
  type GetUserSalesFunnelsResponse,
  type GetSalesFunnelLeadsResponse,
} from './types';
